import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderBlock } from './features/blocks/header/header.block';
import { FooterBlock } from './features/blocks/footer/footer.block';
import { ToastBlock } from './features/blocks/toast/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderBlock, FooterBlock, ToastBlock],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('mario-front');
}
